import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col, Accordion, Card, Row, Spinner } from "react-bootstrap";
import ApiSupplier from "../../../core/api/api.supplier";
import _ from "lodash";
import ApiAgent from "../../../core/api/api.agent";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { ViewAndUpdateAgent } from "./ViewAndUpdateAgent";
import { AddEditeModalUserClaims } from "./AddEditeModalUserClaims";
import { AddSupplierToAgentModal } from "./AddSupplierToAgentModal";
import { numberRegex, tools } from "../../../core/utils/tools";
import { CreateAgentModal } from "./CreateAgentModal";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import EditUserNameModal from "./EditUserNameModal";
import SelectComponent from "../_Components/ReactSelectComponent";
import { TextField } from "@mui/material";
import GlobalFormControl from "../_Components/GlobalFormControl";
import ApiRegion from "../../../core/api/api.region";

const Agent = () => {
  const [listData, setListData] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [refresh, setRefresh] = useState(false);
  const [showModalAgent, setShowModalAgent] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [showModalUserClaims, setShowModalUserClaims] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showModalEditUserName, setShowModalEditUserName] = useState(false);
  const [showAddSupplierToAgentModal, setShowAddSupplierToAgentModal] = useState(false);
  const [suppliers, setSuppliers] = useState([])
  const [allAmusementCityList, setAllAmusementCityList] = useState([]);
  const [isSelectOtherCityElseKish, setIsSelectOtherCityElseKish] = useState(false)
  const [agents, setAgents] = useState([]);
  const [createModalAgent, setCreateModalAgent] = useState(false);
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
  useEffect(() => {
    (async () => {
      try {
        const data = await ApiAgent.getAllAgent({
          ceoFirstName: searchParams.get("ceoFirstName"),
          ceoLastName: searchParams.get("ceoLastName"),
          phoneNumber: searchParams.get("phoneNumber"),
          companyNationalId: searchParams.get("companyNationalId"),
          agentId: searchParams.get("agentId"),
          cityIdList: searchParams.get("cityIdList"),
          globalSearch: searchParams.get("globalSearch"),
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
        });
        const allAmusementCityLists = await ApiRegion.getAllCity();
        const kish = allAmusementCityLists.filter(city => city.name == 'کیش').map((item) => ({
          value: item.id,
          label: item.id + "-" + item.name,
        }))
        const otherCities = allAmusementCityLists.filter(city => city.name != 'کیش' && city.id != 0).map((item) => ({
          value: item.id,
          label: item.id + "-" + item.name,
        }))
        setAllAmusementCityList([
          {
            label: 'شهر های مورد علاقه',
            options: [...kish, { label: "سایر شهرها به جز کیش", value: 0 }]
          },
          {
            label: "همه شهر های ایران",
            options: otherCities
          }
        ]);
        setListData(data);
        setValue("totalCount", data.totalCount);
        const allSuppliers = await ApiSupplier.getAllSuppliersName();
        setSuppliers(allSuppliers);
        const agentsResponse = await ApiAgent.getAllAgentsName();
        setAgents(agentsResponse);
        const formInputs = [
          { name: "ceoFirstName", type: "text" },
          { name: "ceoLastName", type: "text" },
          { name: "phoneNumber", type: "text" },
          { name: "companyNationalId", type: "text" },
          {
            name: "supplierId",
            type: "multiSelect",
            isMulti: false,
            data: suppliers?.map((item) => ({
              id: item.id,
              title: item.companyName,
            })),
          },
          { name: "cityIdList", type: "multiSelect", isMulti: true, data: allAmusementCityList },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);

      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, [refresh]);

  useEffect(() => {
    setAllAmusementCityList(prev => {
      const otherCities = prev[1]?.options
      const cities = prev[0]?.options
      const disabledOtherCities = otherCities?.map(city => ({ ...city, isDisabled: isSelectOtherCityElseKish })) || []
      const disabledCities = cities?.map(city => ({ ...city, isDisabled: isSelectOtherCityElseKish })) || []

      return [{ ...prev[0], options: disabledCities }, { ...prev[1], options: disabledOtherCities }]
    })

  }, [getValues("cityIdList")])

  const onSubmit = async (data) => {
    if (data.cityIdList?.length > 0) data.cityIdList = _.toString(data.cityIdList?.map((item) => item.value));
    tools.setPageNumber(data, searchParams, setValue);
    data.agentId = data.agentId?.value;
    const apiData = await ApiAgent.getAllAgent(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    const queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/agentList?${queryString}`);
  };

  const callBackJustForRunUseEffect = () => {
    setRefresh(!refresh);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت نمایندگان</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست نماینده های ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <Button
              onClick={() => {
                setCreateModalAgent(true);
              }}
            >
              <AddCircle className="mr-1" />
              ایجاد نماینده جدید
            </Button>
          </div>
        </div>

        {/*Start body */}

        <div className="card-body pt-3 pb-0">
          {/* search box */}
          <div className="border-top pt-3">
            <FormProvider {...methods}>
              <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>
                          <Col sm="6" xl="3" className="  px-2 pt-5">
                            <Controller
                              name="agentId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-0"
                                  placeholder="نام شرکت"
                                  options={agents?.map((item) => ({
                                    value: item.id,
                                    label: item.companyName,
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="phoneNumber"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label=" شماره تماس"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={(e) => {
                                    if (e.target.value && (!numberRegex.test(e.target.value) || e.target.value.length > 11)) {
                                      e.target.value = getValues("phoneNumber")
                                      return
                                    }
                                    onChange(e)
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="ceoFirstName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام مدیر عامل"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="ceoLastName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام خانوادگی مدیر عامل"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="companyNationalId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label=" شناسه ملی شرکت"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="cityIdList"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className=" mt-5"
                                  placeholder="شهر"
                                  options={allAmusementCityList}
                                  isMulti
                                  field={field}
                                  onChange={(selectedCities) => {
                                    let confirmValues = selectedCities;
                                    if (selectedCities.find(item => item.value == 0)) {
                                      setIsSelectOtherCityElseKish(true)
                                      confirmValues = selectedCities.filter(city => city.value == 0)
                                    }
                                    else
                                      setIsSelectOtherCityElseKish(false)
                                    field.onChange(confirmValues)
                                  }}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" className="tb-reponsive mt-3">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              variant="light-danger ml-2"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsSelectOtherCityElseKish(false)
                                tools.handleResetAdvanceSearchBox(watch, reset)
                              }}
                            >
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
                {/* table */}
                <Col xs="12" className="tb-reponsive px-0">
                  <DataGrid
                    data={listData}
                    callBack={callBackJustForRunUseEffect}
                    setShowModalAgent={setShowModalAgent}
                    setSelectedAgent={setSelectedAgent}
                    setShowModalUserClaims={setShowModalUserClaims}
                    setSelectedUser={setSelectedUser}
                    setShowModalEditUserName={setShowModalEditUserName}
                    setShowAddSupplierToAgentModal={setShowAddSupplierToAgentModal}
                  />
                </Col>
                {showModalAgent && (
                  <ViewAndUpdateAgent
                    showModalAgent={showModalAgent}
                    setShowModalAgent={setShowModalAgent}
                    selectedAgent={selectedAgent}
                  />
                )}
                {showModalUserClaims && (
                  <AddEditeModalUserClaims
                    showModalUserClaims={showModalUserClaims}
                    setShowModalUserClaims={setShowModalUserClaims}
                    selectedUser={selectedUser}
                  />
                )}
                {createModalAgent && (
                  <CreateAgentModal
                    createModalAgent={createModalAgent}
                    setCreateModalAgent={setCreateModalAgent}
                    callBackJustForRunUseEffect={callBackJustForRunUseEffect}
                  />
                )}
                {showAddSupplierToAgentModal && (
                  <AddSupplierToAgentModal
                    showAddSupplierToAgentModal={showAddSupplierToAgentModal}
                    setShowAddSupplierToAgentModal={setShowAddSupplierToAgentModal}
                    selectedUser={selectedUser}
                    suppliers={suppliers}
                  />
                )}
                {showModalEditUserName && (
                  <EditUserNameModal
                    showModalEditUserName={showModalEditUserName}
                    setShowModalEditUserName={setShowModalEditUserName}
                    selectedUser={selectedUser}
                  />
                )}
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Agent;
